// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_gj-2";
export var aiChatCartContainerExit = "_gj-4";
export var aiChatContainerLarge = "_gj-0";
export var aiChatContainerSmall = "_gj-1";
export var aiChatIcon = "_gj-6";
export var slideInFromRight = "_gj-3";
export var slideOutToRight = "_gj-5";